import type { FaireProductEntity } from "../../entity_types/product";

export const p_en6hwxne72: FaireProductEntity = {
  token: "p_en6hwxne72",
  type: "product",
  name: "Good Grief Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/098099d4bdc4ec57f6169a17dab96be1073460313d459522cf70c2e6da5ddee0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6eefba31fd344d741b833a77f4de4a0e041ce3d26fc92fe0fc57cebbda5ed89.jpeg",
    "https://cdn.faire.com/fastly/09ccf1d9a4fa6bba97cca9d90d521409c440e429a40b09948068a3848559a961.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/40b9c0a0aea3182494de2c0b66d69b2abc9171507c0e8fb1a8a2dce0fce11c86.jpeg",
    "https://cdn.faire.com/fastly/9f7835b156baaab1d9c7fb0e3d36b571515e2098401612705920b6b8d1d29e01.jpeg",
    "https://cdn.faire.com/fastly/45abb2b37e11e41cef9abad64d77a15e3ce1504eb539f30cb2758fbf3ee0f168.jpeg",
    "https://cdn.faire.com/fastly/fbd308e1a6837b381ef253d05115acb2a734039cd903ae4967aa8ed34b48df05.jpeg"
  ],
  priceDollars: 3.38,
  description: "These socks are for when one sigh just isn’t enough.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:10.450Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
